<template>
  <div>
    <el-dialog title="设置基础点赞量"
               :visible.sync="dialogFormVisible"
               width="500px"
               top="10px"
               @close="handleClose()"
               @open="open()">
      <el-form ref="userForm"
               label-width="50px"
               style="width:300px"
               class="userForm">
        <el-form-item label="当前点赞量"
                      label-width="140px">
          <div class="inputBox">
            {{userForm.total_like_count}}个
          </div>
        </el-form-item>
        <el-form-item label="选择基础点赞量区间"
                      label-width="140px">
          <div class="rangeContent">
            <div v-for="(item,index) in NumRanges"
                 :key="index"
                 class="rangeItem"
                 :class="{'active':item.flag}"
                 @click="handleClick(item)">{{item.label}}

              <img src="https://upload.kaoyanbox.net/0474a5bcc4fed067ae81ab68267e6c68.png"
                   class="checkImg"
                   v-if="item.flag" />

            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="handleClose()">取消</div>
        <div class="confirm"
             @click="handleConfirm()">确认</div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { notePut, commentPut } from '@/api/senior'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    detailId: {
      type: Number,
      default: () => {
        return null
      },
    },
    authorId: {
      type: Number,
      default: () => {
        return null
      },
    },
    total_like_count: {
      type: Number,
      default: () => {
        return null
      },
    },
    type: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      currentSrc: '',
      dialogFormVisible: this.isVisible,
      userForm: {
        total_like_count: 0,
      },
      NumRanges: [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: false },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
        {
          id: 5,
          label: '101-200个',
          minHours: 101,
          maxHours: 200,
          flag: false,
        },
        {
          id: 6,
          label: '201-500个',
          minHours: 201,
          maxHours: 500,
          flag: false,
        },
      ],
      inActive: 0,
      selectedRange: null,
      timeResult: null,
      rangeNum: 0,
      isFlag: false,
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    total_like_count(val) {
      this.userForm.total_like_count = val
    },
    // type(val) {
    //   this.types = val
    //   console.log('this.types', this.types)
    // },
  },
  methods: {
    handleClick(range) {
      range.flag = !range.flag
      if (range.flag) {
        this.NumRanges.map((item) => {
          if (item.id != range.id) {
            item.flag = false
          }
        })
      }
    },
    handleIframeLoad() {},
    handleClose() {
      this.isFlag = false
      this.inActive = 0
      this.$emit('close')
      this.NumRanges = [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: false },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
        {
          id: 5,
          label: '101-200个',
          minHours: 101,
          maxHours: 200,
          flag: false,
        },
        {
          id: 6,
          label: '201-500个',
          minHours: 201,
          maxHours: 500,
          flag: false,
        },
      ]
    },
    handleConfirm() {
      let hasOutOfStock = this.NumRanges.some(function (product) {
        return product.flag == true // 检查是否有库存为 0 的商品
      })
      if (hasOutOfStock) {
        let checkItem = null
        this.NumRanges.map((item) => {
          if (item.flag) {
            checkItem = item
          }
        })
        this.selectedRange = checkItem
        const { minHours, maxHours, label } = checkItem
        this.rangeNum =
          Math.floor(Math.random() * (maxHours - minHours + 1)) + minHours
        if (this.type == '笔记') {
          notePut({
            uid: this.authorId,
            id: this.detailId,
            base_like_count: this.rangeNum,
          }).then((res) => {
            this.$message.success('操作成功!')
            this.handleClose()
          })
        } else if (this.type == '评论') {
          commentPut({
            note_comment_id: this.detailId,
            base_like_count: this.rangeNum,
          }).then((res) => {
            this.$message.success('操作成功!')
            this.handleClose()
          })
        }
      } else {
        this.handleClose()
      }
    },

    open() {},
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.inputBox {
  padding-left: 13px;
  width: 260px;
  font-size: 14px;
  color: #909399;
  line-height: 36px;
  height: 36px;
  background: #f5f5f5;
  border: 1px solid #dcdfe6;
}
.rangeContent {
  width: 300px;
  display: flex;
  flex-flow: wrap;

  .rangeItem {
    cursor: pointer;
    margin-bottom: 16px;
    margin-right: 20px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #dcdcdc;
    padding: 0px 4px;
    position: relative;
    .checkImg {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 14.16px;
      height: 12.5px;
    }
  }
  .active {
    border: 1px solid #1f86fe;
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  .cancle {
    width: 56px;
    text-align: center;
    height: 36px;
    font-weight: 400;
    font-size: 14px;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    margin-right: 20px;
  }
  .confirm {
    width: 56px;
    text-align: center;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    color: #fff;
    background: #1f86fe;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>